
import { Grid, InputAdornment, LinearProgress, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import {
  getTableStructure,
  parseGraqhqlResponse
} from '../../../../utils/index';
import styles, { useStyles } from './styles';

import { CSVLink } from 'react-csv';
import GetAppIcon from '@mui/icons-material/GetApp';
import { FixedSizeList as List } from 'react-window';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import SearchIcon from '@mui/icons-material/Search';
import { Text } from 'shared/components';
import gql from 'graphql-tag';
import { withStyles } from '@mui/styles';

function populateFunction(arr) {
  const mainContain = document.createElement('ul');
  function iterateThrough(obj, elt) {
    // eslint-disable-next-line func-names
    Object.keys(obj).forEach(function(curKey) {
      if (typeof obj[curKey] === 'object') {
        const li = document.createElement('li');
        const tn = document.createTextNode(curKey);
        const ul = document.createElement('ul');
        li.appendChild(tn);
        li.appendChild(ul);
        elt.appendChild(li);
        iterateThrough(obj[curKey], ul);
      } else {
        const li = document.createElement('li');
        const aElt = document.createElement('a');
        aElt.textContent = obj[curKey];
        li.appendChild(aElt);
        elt.appendChild(li);
      }
    });
  }
  iterateThrough(arr, mainContain);
  let cleanedHTML = mainContain.outerHTML;
  if (cleanedHTML !== undefined) {
    cleanedHTML = cleanedHTML.replace(/<li>/g, '#');
    cleanedHTML = cleanedHTML.replace(/<\/li>/g, '\n');
    cleanedHTML = cleanedHTML.replace(/<ul>/g, ' ');
    cleanedHTML = cleanedHTML.replace(/<\/ul>/g, ' ');
    cleanedHTML = cleanedHTML.replace(/<a>/g, '');
    cleanedHTML = cleanedHTML.replace(/<\/a>/g, '');
    cleanedHTML = cleanedHTML.replace('#values', '');
    cleanedHTML = cleanedHTML.replace('  ', '');
  }
  return cleanedHTML;
}

const updateReportData = data => {
  const noEmptyRows = data.filter(
    r =>
      r['Core service (categorical)'] !== null &&
      r['Primary intervention types'] !== null &&
      r['Secondary intervention type'] !== null &&
      r['Tertiary intervention type'] !== null &&
      r['Intervention dosage level'] !== null &&
      r['Intervention dosage number'] !== null
  );
  // eslint-disable-next-line func-names
  const updatedReport = noEmptyRows.map(function(item) {
    const newItem = { ...item };
    if (
      item['Primary intervention types'] !== null &&
      item['Primary intervention types'] !== undefined
    ) {
      const primaryValues = JSON.parse(item['Primary intervention types']);
      const htmlFormatedJSON = populateFunction(primaryValues);

      newItem['Primary intervention types'] = htmlFormatedJSON;
    }
    if (
      item['Secondary intervention type'] !== null &&
      item['Secondary intervention type'] !== undefined
    ) {
      const secondaryValues = JSON.parse(item['Secondary intervention type']);
      const htmlFormatedJSON = populateFunction(secondaryValues);

      newItem['Secondary intervention type'] = htmlFormatedJSON;
    }
    if (
      item['Tertiary intervention type'] !== null &&
      item['Tertiary intervention type'] !== undefined
    ) {
      const tertiaryValues = JSON.parse(item['Tertiary intervention type']);
      const htmlFormatedJSON = populateFunction(tertiaryValues);

      newItem['Tertiary intervention type'] = htmlFormatedJSON;
    }
    return newItem;
  });

  return updatedReport;
};

function TableReport({ success, query, filters, tabId, includeArchived, indicatorsLoaded }) {
  const classes = useStyles();
  const columns = getTableStructure(filters, tabId);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');

  const queryString = '{allPortfolios { edges { node { name investments { edges { node { recipient cashAmount }}}}}}}';
  let REPORT_QUERY = gql`
    ${queryString}
  `;
  if (query.length > 0) {
    REPORT_QUERY = gql`
      ${query}
    `;
  }

  const gridStyle = { textAlign: 'center' };

  if (isLoading) {
    gridStyle.overflow = 'hidden';
  }

  if (!indicatorsLoaded) {
    return (<Grid container direction="row" justify="center" alignItems="center">
      <Typography variant="body1" style={{width: '100%', textAlign: 'center'}}>
        Part of your filters are beign fetch, please wait...
      </Typography>
    </Grid>);
  }

  if (!success) {
    return (
      <Grid container direction="row" justify="center" alignItems="center">
        <Typography variant="body1" style={{width: '100%', textAlign: 'center'}}>
          Please select a report and run it to continue
        </Typography>
      </Grid>);
  }

  const getHeight = () => {
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    return (height >= 500) ? (height - 200) : 300;
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        { success && (
          <Grid item xs={12} style={gridStyle}>
            <div>
              <Typography variant="body1" style={{color: '#0091ae', textAlign: 'center'}}>
                Your report is begin generated, please check your email address in a few minutes to download it.
              </Typography>
            </div>
          </Grid>
        )}

        { /*success && (
          <Grid item xs={12} style={gridStyle}>
            <Query
              query={REPORT_QUERY}
              fetchPolicy="network-only"
              context={{
                headers: {
                  'ti-archived': includeArchived ? 'true' : 'false'
                }
              }}
            >
              {({ loading, error, data }) => {
                setIsLoading(loading);
                let report = parseGraqhqlResponse(data, filters);
                if (tabId === 2 && report.length > 0 && report !== undefined) {
                  report = updateReportData(report);
                }
                if (loading)
                  return (
                    <div>
                      <LinearProgress variant="query"/>
                      <Typography variant="body1" style={{color: '#0091ae', textAlign: 'center'}}>
                        REPORT IS BEING GENERATED
                      </Typography>
                    </div>
                  );
                if (error)
                  return (
                    <div><Text>An unexpected error ocurred, please try again.</Text></div>
                  );

                if (columns.length === 0) {
                  return <span>Create a new report and select some fields to continue </span>
                }

                const rows = (search) ? report.filter(row => {
                  const rowData = columns.reduce((acc, col) => { return acc + row[col.field]}, '').toLowerCase()
                  return rowData.includes(search.toLowerCase()) 
                }) : report;

                const totalRows = rows.length;
                const totalCells = columns.length;
    
                const Row = ({ index: i, style }) => {
                  const index = i - 1;
                  if (index >= 0){
                    return (
                      <div
                        className={index % 2 ? classes.rowOdd : classes.rowEven}
                        key={rows[index].name}
                        style={{...style, width: (totalCells*100) + 2}}
                      >
                        {columns.map(({field: cell}) => <div className={classes.cell}>{rows[index][cell]}</div>)}
                      </div>
                    )
                  }
                  return (
                    <div className={classes.rowHead} key={index} style={{...style, width: (totalCells*100) + 2}}>
                      {columns.map(({title}) => <div className={classes.cell}>{title}</div>)}
                    </div>
                  );
                }

                return (<div>
                  <div className={classes.filters}>
                    <TextField
                      label="Search"
                      variant="outlined"
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>
                      }}
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />
                    <CSVLink
                      className={classes.csvLink}
                      filename='report.csv'
                      data={rows}
                      headers={columns.map(c => c.title)}>
                      Download report <GetAppIcon className={classes.download}/>
                    </CSVLink>
                  </div>
                  <List
                    className="List"
                    height={getHeight()}
                    itemCount={totalRows + 1}
                    itemSize={60}
                    width="calc(100vw - 40px)"
                  >
                    {Row}
                  </List>
                </div>)
              }}
            </Query>
          </Grid>
        )*/}
      </Grid>
    </>
  );
}

TableReport.propTypes = {
  success: PropTypes.bool,
  query: PropTypes.string,
  filters: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  tabId: PropTypes.number,
  includeArchived: PropTypes.bool,
};

export default withStyles(styles)(TableReport);
